import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../Management.css';
import { useEffect, useState } from 'react';
import AddEvent from './AddEvent';
import { IEventResponseModel } from '../../../interfaces/responses/IEventResponseModel';
import { deleteEvent, getAllEvents } from '../../../http/eventAPI';
import EditEvent from './EditEvent';

const EventManage: React.FC = () => {
    const [show, setShow] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState<IEventResponseModel | null>(null);
    const [eventToDelete, setEventToDelete] = useState<string | null>(null);
    const [events, setEvents] = useState<IEventResponseModel[]>([]);
    const [error, setError] = useState<string | null>(null);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseEdit = () => setSelectedEvent(null);
    const handleShowEdit = (event: IEventResponseModel) => setSelectedEvent(event);

    const fetchEvents = async () => {
        const result = await getAllEvents();
        if (Array.isArray(result)) {
            setEvents(result);
        } else {
            setError('Ошибка при получении событий');
        }
    };

    const handleEdit = (event: IEventResponseModel) => {
        handleShowEdit(event);
    };

    const handleDeleteClick = (id: string) => {
        setEventToDelete(id);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        if (eventToDelete) {
            const error = await deleteEvent(eventToDelete);
            if (error) {
                setError(error);
            } else {
                setEvents(events.filter(event => event.id !== eventToDelete));
                setError(null);
            }
            setShowDeleteModal(false);
            setEventToDelete(null);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    return (
        <div className="manage_container">
            <Button variant='success' onClick={handleShow}>Добавить событие</Button>
            <AddEvent show={show} handleClose={handleClose} onEventCreated={fetchEvents} />
            {selectedEvent && (
                <EditEvent
                    show={!!selectedEvent}
                    handleClose={handleCloseEdit}
                    onEventEdited={fetchEvents}
                    eventId={selectedEvent.id}
                />
            )}
            <div className="event_list">
                {error ? (
                    <div>{error}</div>
                ) : (
                    <div className='event_list'>
                        <table className='event_table'>
                            <thead>
                                <tr>
                                    <th>Название</th>
                                    <th>Описание</th>
                                    <th>Локация</th>
                                    <th>Фото</th>
                                    <th>Даты и Типы билетов</th>
                                    <th>Дата создания</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {events.map(event => (
                                    <tr key={event.id}>
                                        <td>{event.title}</td>
                                        <td>
                                            {event.description.length > 200
                                                ? `${event.description.substring(0, 200)}...`
                                                : event.description}
                                        </td>
                                        <td>{event.location}</td>
                                        <td>
                                            <img
                                                src={`https://minio.greenspacegg.ru:9000/meart/${event.image}`}
                                                alt={event.title}
                                                width="100"
                                                height="100"
                                            />
                                        </td>
                                        <td>
                                            {event.eventDatesAndTickets.map((eventDate, index) => (
                                                <div key={index} className='date_tickets'>
                                                    <div><strong>Дата:</strong> {new Date(eventDate.start_time).toLocaleString()}</div>
                                                    {eventDate.ticketTypes.map((ticket, ticketIndex) => (
                                                        <div key={ticketIndex}>
                                                            <strong>Тип билета:</strong> {ticket.type}, <strong>Цена:</strong> {ticket.price} ₽, <strong>Всего билетов:</strong> {ticket.total_tickets}, <strong>Забронировано:</strong> {ticket.booked_tickets || 0};
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </td>
                                        <td>{new Date(event.createdAt).toLocaleString()}</td>
                                        <td><Button variant='dark' onClick={() => handleEdit(event)}>Редактировать</Button></td>
                                        <td><Button variant='danger' onClick={() => handleDeleteClick(event.id)}>Удалить</Button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Подтверждение удаления</Modal.Title>
                </Modal.Header>
                <Modal.Body>Вы уверены, что хотите удалить это событие?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Отмена
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm}>
                        Удалить
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default EventManage;